import { ShellPreferencesProvider } from '@/shared/shell/ShellPreferencesContext';
import Layout from './Layout';

/**
 * Layout autenticato. I dati si caricano per pagina tramite React Query.
 * Login/marketing restano fuori da questo albero.
 */
function FleetLayout() {
  return (
    <ShellPreferencesProvider>
      <Layout />
    </ShellPreferencesProvider>
  );
}

export default FleetLayout;
